import { generateLabelsW2W } from './pdf-labels/labels-w2w'
import { generateLabelsSoftwood } from './pdf-labels/labels-softwood'
import { generateLabelsOlympic } from './pdf-labels/labels-olympic'
import { generateLabelsNordic } from './pdf-labels/labels-nordic'

function findTheFontSize (docDefinition) {
  if (docDefinition) {
    for (let i = 0; i < docDefinition.content.length; i++) {
      const text = docDefinition.content[i] && docDefinition.content[i].text
      if (text) {
        if (text.length === 8) {
          docDefinition.content[i].fontSize = 105
          docDefinition.content[i].margin = [0, 10, 0, 10]
        } else if (text.length === 9) {
          docDefinition.content[i].fontSize = 110
          docDefinition.content[i].margin = [0, 23, 0, 23]
        } else if (text.length === 10) {
          docDefinition.content[i].fontSize = 95
          docDefinition.content[i].margin = [0, 27, 0, 27]
        } else if (text.length === 11) {
          docDefinition.content[i].fontSize = 85
          docDefinition.content[i].margin = [0, 35, 0, 35]
        } else if (text.length === 12) {
          docDefinition.content[i].fontSize = 75
          docDefinition.content[i].margin = [0, 35, 0, 35]
        } else if (text.length > 13) {
          docDefinition.content[i].fontSize = 55
          docDefinition.content[i].margin = [0, 35, 0, 35]
        }
      }
    }
  }
}


export const generateManyPagesForContent = ({
    packages_data = [],
    logo_w2w = '',
    pp = '',
    wood_certificates = ''
  }, labelType = 'softwood') => {
  if (labelType === 'w2w') {
    return generateLabelsW2W(packages_data, logo_w2w, wood_certificates, findTheFontSize)
  } else if (labelType === 'olympic') {
    return generateLabelsOlympic(packages_data, pp, findTheFontSize)
  } else if (labelType === 'nordic') {
    return generateLabelsNordic(packages_data, pp, findTheFontSize)
  }
  return generateLabelsSoftwood(packages_data, pp, findTheFontSize)
}



// WEBPACK FOOTER //
// ./src/helpers/createPdfLabel.js